// src/components/SessionReplayControl.js
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { datadogRum } from '@datadog/browser-rum';

const SessionReplayControl = () => { //session replay control on page level.
  const location = useLocation();
  useEffect(() => {
    const currentPath = location.pathname;
    if (currentPath.toLowerCase().startsWith("/payment")) {
      datadogRum.startSessionReplayRecording();
    } else {
      datadogRum.stopSessionReplayRecording();
    }
  }, [location]);

  return null;
};

export default SessionReplayControl;
